import { Component, computed, signal, OnInit, Output, EventEmitter } from '@angular/core';
import { AppModule } from '../../app.module';
import { IncidentService } from '../../shared/incident.service';
import { NotificationService } from '../../shared/notification.service';
import { IncidentStatusCategory, UserType } from '../../shared/enums';
import { DashboardStats, Incident } from '../../models/incident';
import { WhatsappService } from '../../whatsapp/whatsapp.service';
import { SharedDataService } from '../../shared/shareddata.service';
import { Router } from '@angular/router';
import { AuthService } from '../../auth.service';
import { ClientService } from '../../shared/client.service';
import { BreakdownTechnician } from '../../models/client';
import { User } from '../../models/user';

@Component({
  selector: 'app-stats',
  imports: [AppModule],
  templateUrl: './stats.html',
  styleUrl: './stats.less'
})
export class Stats implements OnInit {
  @Output() whatsappOpened = new EventEmitter<void>();

  isTechniciansModalVisible = false;
  isAddTechnicianPanelOpen = false;
  newTechnician: User = new User();
  dynamicSpan = 12;
  // Computed properties using the centralized service
  public todayStats = computed(() => this.incidentService.getTodayStats());
  public isLoadingTodayIncidents = computed(() => this.incidentService.isLoadingOpenIncidents());
  public dashboardStats = signal<DashboardStats | undefined>(undefined);
  constructor(
    private incidentService: IncidentService,
    private notification: NotificationService,
    public whatsappService: WhatsappService,
    public sharedDataService: SharedDataService,
    public clientService: ClientService,
    private router: Router,
    public authService: AuthService
  ) {
    this.initializeNewTechnician();
  }

  ngOnInit(): void {
    this.loadData();

    if (this.authService.hasClaims(['BDT'])) {
      this.dynamicSpan = 16;
    } else {
      this.dynamicSpan = 24;
    }
  }

  private loadData(): void {
    this.incidentService.loadDashboardStats().subscribe({
      next: (stats) => {
        // Assuming the API returns an object with the necessary stats
        this.dashboardStats.set(stats);
      },
      error: (error) => {
        this.notification.handleError(error, 'Failed to load dashboard stats');
      }
    });
  }

  public get breakdownsToday(): number {
    return this.todayStats().breakdownsToday;
  }

  public get cancelledIncidentsToday(): number {
    return this.todayStats().cancelledIncidentsToday;
  }

   public get newIncidentCount(): number {
    return this.incidentService.getOperatorStats(this.authService.user?.clientId).newIncidentCount;
  }

  public get openIncidentCount(): number {
    return this.incidentService.getOperatorStats(this.authService.user?.clientId).openIncidentCount;
  }

  public onClickNewBreakdowns() {
    const incidentId = this.incidentService.getFirstNewIncidentId(this.authService.user?.clientId);
    if (incidentId) {
      this.router.navigate(['/incident', incidentId]);
    }
  }

  public onClickAllBreakdowns() {
    this.router.navigate(['/incidents']);
  }

  public onClickOpenWhatsappMessages(): void {
    this.sharedDataService.isWhatsappDrawerVisible = true;
    this.whatsappOpened.emit();
  }

  public getBreakdownTechnicianCountPerStatus(statusId: number | null): number {
    return this.sharedDataService.breakdownTechnicians.filter(bt => bt.statusId === statusId).length;
  }

  public openTechniciansModal(): void {
    this.isTechniciansModalVisible = true;
  }

  public closeTechniciansModal(): void {
    this.isTechniciansModalVisible = false;
  }

  public updateTechnicianStatus(technician: BreakdownTechnician, statusId: number): void {
    // statusId: 1 = READY, 2 = UNAVAILABLE, 3 = ON BREAKDOWN
    console.log(`Updating technician ${technician.name} to status ${statusId}`);
    this.clientService.updateBreakdownTechnicianStatus(technician.driverId, statusId).subscribe({
      next: (updatedTechnicians) => {
        this.sharedDataService.breakdownTechnicians = updatedTechnicians;
        this.notification.showSuccess(`Technician ${technician.name} status updated successfully.`);
      },
      error: (error) => {
        this.notification.handleError(error, `Failed to update status for technician ${technician.name}`);
      }
    });
  }

  private initializeNewTechnician(): void {
      this.newTechnician.lat = Number(this.newTechnician.lat) || -28.5;
    this.newTechnician.lon = Number(this.newTechnician.lon) || 24.6;
    this.newTechnician.clientId = this.authService.user?.clientId || 0;
    this.newTechnician.userType = UserType.technician; 
  }

  public addTechnician(): void {
    this.clientService.upsertTechnician(this.newTechnician).subscribe({
      next: (addedTechnician) => {
        this.sharedDataService.breakdownTechnicians.push(addedTechnician);
        this.notification.showSuccess(`Technician ${addedTechnician.name} added successfully.`);
        this.isAddTechnicianPanelOpen = false;
        this.initializeNewTechnician();
      },
      error: (error) => {
        this.notification.handleError(error, 'Failed to add technician');
      }
  });
}
}